export default __webpack_public_path__ + "static/media/MedicineOrderIcon.b5cfec04.svg";